// Copyright (c) 2026 Celadon Development LLC, All rights reserved.
// Author Vasily Klyuev <vasily.klyuev@celadon.ae>
const REDEEM_START_LOADER = 'REDEEM_START_LOADER';
const REDEEM_STOP_LOADER = 'REDEEM_STOP_LOADER';

const REDEEM_CHANGE_CODE = 'REDEEM_CHANGE_CODE';
const REDEEM_CHANGE_AMOUNT = 'REDEEM_CHANGE_AMOUNT';

const REDEEM_SCAN_VOUCHER = 'REDEEM_SCAN_VOUCHER';
const REDEEM_SCAN_VOUCHER_SUCCESS = 'REDEEM_SCAN_VOUCHER_SUCCESS';

const REDEEM_VOUCHER = 'REDEEM_VOUCHER';
const REDEEM_VOUCHER_SUCCESS = 'REDEEM_VOUCHER_SUCCESS';

const REDEEM_SET_MESSAGE = 'REDEEM_SET_MESSAGE';
const REDEEM_RESET = 'REDEEM_RESET';

export {
  REDEEM_START_LOADER,
  REDEEM_STOP_LOADER,

  REDEEM_CHANGE_CODE,
  REDEEM_CHANGE_AMOUNT,

  REDEEM_SCAN_VOUCHER,
  REDEEM_SCAN_VOUCHER_SUCCESS,

  REDEEM_VOUCHER,
  REDEEM_VOUCHER_SUCCESS,

  REDEEM_SET_MESSAGE,
  REDEEM_RESET,
};
